<template>
  <local-item :data="group" />
  <local-keys :data="keys" v-if="groupId == 18" />

  <div class="all" v-else>
    <p-vue-panel
      :header="__('Responsible supplier details')"
      class="p-panel--block"
      :class="responsibleSupplierDetails.length > 1 ? 'suppliers' : ''"
      v-if="responsibleSupplierDetails.length > 0"
    >
      <local-suppliers
        :data="responsibleSupplierDetails[0]"
        v-if="responsibleSupplierDetails.length == 1"
      />
      <p-vue-carousel
        :value="responsibleSupplierDetails"
        class="custom-carousel"
        :circular="true"
        :autoplayInterval="5000"
        v-else
      >
        <template #item="slotProps">
          <local-suppliers :data="slotProps.data" />
        </template>
      </p-vue-carousel>
    </p-vue-panel>
    <p-vue-panel
      :header="__('Maintenance plan')"
      class="p-panel--block"
      :class="maintenancePlan.length > 1 ? 'maintenancePlan' : ''"
      v-if="maintenancePlan.length > 0"
    >
      <local-maintenance-plan
        :data="maintenancePlan[0]"
        v-if="maintenancePlan.length == 1"
      />
      <p-vue-carousel
        :value="maintenancePlan"
        class="custom-carousel"
        :circular="true"
        :autoplayInterval="5000"
        v-else
      >
        <template #item="slotProps">
          <local-maintenance-plan :data="slotProps.data" />
        </template>
      </p-vue-carousel>
    </p-vue-panel>
    <p-vue-panel
      :header="__('Facility data')"
      class="p-panel--block"
      v-if="facilityData != ''"
    >
      <div :innerHTML="facilityData"></div>
    </p-vue-panel>
    <p-vue-panel
      v-for="(item, index) in lastServiceCalls"
      :key="index"
      :header="!index ? '10 ' + __('Recent service calls') : null"
      :class="{
        'p-no-header': index,
        'p-panel--block': true,
      }"
    >
      <div class="grid">
        <div v-if="item.PID">
          <label>{{ __("Reading") }}</label>
          <span>{{ item.PID }}</span>
        </div>
        <div v-if="item.Subject">
          <label>{{ __("Topic") }}</label>
          <span>{{ item.Subject }}</span>
        </div>
      </div>

      <div class="grid">
        <div v-if="item.OpenDateStr">
          <label>{{ __("Date") }}</label>
          <span>{{ item.OpenDateStr }}</span>
        </div>
        <div v-if="item.statusDesc">
          <label>{{ __("Status") }}</label>
          <span>{{ item.statusDesc }}</span>
        </div>
      </div>

      <div class="grid">
        <div v-if="item.LastDateUpdateStr && item.lastUpdateDesc">
          <label>{{ __("Last update") }}</label>
          <span>{{ item.LastDateUpdateStr }}</span>
        </div>
        <div v-if="item.lastUpdateDesc">
          <label>{{ __("Content of the update") }}</label>
          <span>{{ item.lastUpdateDesc }}</span>
        </div>
      </div>
      <div class="attachments" v-if="item.Images.length > 0">
        <label>{{ __("Photos") }}</label>
        <ul>
          <li v-for="(image, index) in item.Images" :key="index">
            <a
              href="#"
              @click.prevent="showBigImg(image.PathImg, item.Images)"
            >
              {{ __("Picture") }} {{ image.Subject }}
            </a>
          </li>
        </ul>
      </div>
    </p-vue-panel>
  </div>
  <p-img
    v-if="showImg"
    :imgPath="showImg"
    :openModal="true"
    @return="showImg = null"
    :allImages="allImages"
  />
</template>

<script>
import LocalItem from "./item";
import LocalKeys from "./keys";
import LocalSuppliers from "./suppliers";
import LocalMaintenancePlan from "./maintenancePlan";
import { callProc, apiParam, apiPType, API_HOST } from "@/services/APointAPI";
import { mapState } from "vuex";
import PImg from "@/components/partials/p-img";
import { errorReceived } from "@/services/apointUtil";

export default {
  components: {
    PImg,
    LocalKeys,
    LocalItem,
    LocalSuppliers,
    LocalMaintenancePlan,
  },
  data() {
    return {
      groupId: 0,
      group: null,
      facilityData: "",
      lastServiceCalls: [],
      maintenancePlan: [],
      responsibleSupplierDetails: [],
      keys: [],
      API_HOST,
      showImg: null,
      allImages: [],
    };
  },
  methods: {
    getData() {
      let procParams = [
        apiParam("BID", this.bID, apiPType.Int),
        apiParam("GroupId", this.groupId, apiPType.Int),
      ];
      callProc("TennatApp_MaintenanceAndFacilities", procParams)
        .then((result) => {
          result = JSON.parse(result);
          /*
            בקריאה זו חוזרות 7 טבלאות:
            Table - פרטי סוג תחזוקה
            Table1 - הסכמי שירות - ספקים
            Table2 - אירועים מחזוריים - תוכניות תחזוקה
            Table3 - נתוני מתקן
            Table4 - היסטורית פניות - קריאות שירות אחרונות
            Table5 - תמונות לפנייה
          */
          this.group = result.Table[0];
          this.responsibleSupplierDetails = result.Table1;
          this.maintenancePlan = result.Table2;
          this.facilityData = result.Table3[0].FacilityData;
          this.lastServiceCalls = result.Table4;
          this.lastServiceCalls.forEach((problem) => {
            problem.Images = result.Table5.filter((f) => f.PID == problem.PID);
          });
        })
        .catch(() => {
          errorReceived("TennatApp_MaintenanceAndFacilities");
        });
    },
    getKeys() {
      let procParams = [
        apiParam("BID", this.bID, apiPType.Int),
        apiParam("GroupId", this.groupId, apiPType.Int),
      ];
      callProc("TennatApp_Keys", procParams)
        .then((result) => {
          result = JSON.parse(result);
          this.group = result.Table[0];
          this.keys = result.Table1;
        })
        .catch(() => {
          errorReceived("TennatApp_Keys");
        });
    },
    showBigImg(imgID, images) {
      this.showImg = imgID;
      this.allImages = images.map((img) => {
        return { imgPath: img.PathImg, imgSubject: img.Subject };
      });
    },
  },
  mounted() {
    this.groupId = this.$route.params.id;
    if (this.groupId == 18) this.getKeys();
    else this.getData();
  },
  computed: {
    ...mapState({
      bID: (state) => state.api.bID,
      sessionToken: (state) => state.api.sessionToken,
    }),
  },
  watch: {
    bID() {
      this.$router.push({ name: "MaintenanceAndFacilities" });
    },
  },
};
</script>

<style scoped>
header {
  gap: 15px;
  display: grid;
  align-items: center;
  grid-template-columns: 37px 1fr;

  padding: 10px 15px;

  border-bottom: 1px solid var(--color-border-alt);

  color: var(--color-primary);
}

header:deep(.svg){
  width: 37px;
  height: 37px;
}

.service-name {
  margin: 0;

  font-size: 15.5px;
  font-weight: normal;
  letter-spacing: normal;
}

:deep(.p-panel-header) {
  padding: 20px 15px 15px;
}

.p-panel--block:deep(.p-panel-content) {
  display: flex;
  flex-direction: column;
}

.all:deep(.p-panel--block.p-no-header .p-panel-content) {
  padding-top: 20px;
}

.p-panel--block:deep(.p-panel-content .grid) {
  gap: 15px;
  display: grid;
  grid-template-columns: 40% 50%;
}

.p-panel--block:deep(.p-panel-content .grid > div) {
  display: flex;
  flex-direction: column;

  line-height: 1;
  font-size: 14px;
  font-weight: normal;
  letter-spacing: 0.45px;
}

.p-panel--block:deep(.p-panel-content .grid + *) {
  margin-top: 15px;
}

.p-panel--block:deep(.p-panel-content) {
  border-bottom-color: var(--color-border-alt);
}

.p-panel--block:deep(.p-panel-content div label) {
  margin-bottom: 5px;

  color: var(--color-primary);
}

:deep(a) {
  text-decoration: underline;
  color: var(--color-success-active);
}

.p-panel:deep(.p-panel-header .p-panel-title) {
  font-size: 14px;
  font-weight: bold;
  color: black;
}

:deep(.p-panel--block:last-child .p-panel-content) {
  border-bottom: none;
}

.attachments ul {
  display: flex;
  flex-wrap: wrap;

  margin: 0;
  padding: 0;

  list-style: none;
}

.attachments ul li a {
  letter-spacing: 0.45px;
  color: var(--color-success-active);
}

.attachments ul li:not(:last-child) a:after {
  content: ",";
}

:deep(.p-carousel-item) {
  direction: rtl;
}

:deep(.p-carousel-content) {
  direction: ltr;
}

.maintenancePlan:deep(.p-panel-content),
.suppliers:deep(.p-panel-content) {
  padding: 0;
}

:deep(.p-carousel .p-carousel-indicators .p-carousel-indicator button) {
  width: 0.5rem;
}
</style>
